export const getSiblings = (params) => {
    let element = params.hasOwnProperty("element") ? 
                      params.element : false
    let selector = params.hasOwnProperty("selector") ? 
                                        params.selector : false

	// Setup siblings array and get the first sibling
	let siblings = []
	let sibling = element.parentNode.firstChild

	// Loop through each sibling and push to the array
	while (sibling) {
		if (sibling.nodeType === 1 && sibling !== element) {
            if(!selector || sibling.matches(selector)) {
                siblings.push(sibling)
            }
		}
		sibling = sibling.nextSibling
	}

	return siblings;

}
